module.exports = __webpack_public_path__ + "img/left_hover.7384bce4.svg";